module.exports = __webpack_public_path__ + "static/media/ad-nnlive-mobile.579283f5.png";